import { useState, useEffect, FC } from 'react';
import { useDispatch } from 'react-redux'

import constsApi from '../../../../services/constsApi';

import { setShowEditAgentsModal } from '../../../../store/internal'

import { AppRequesterController } from '../../../../services/appRequester/appRequesterController';
import { useNavigate } from 'react-router-dom';
import { ModalEditAgentsInterface } from './indexModel';
import { useTranslation } from 'react-i18next';

import i18n from "../../../../i18next"
import ModalEditAgents from '.';

const AppRequesterConst = new AppRequesterController();

const ModalEditAgentsController: FC<ModalEditAgentsInterface> = (props) => {

    const { t } = useTranslation();
    const [/*isLoading*/, setIsLoading] = useState(false)
    const [validated] = useState(false);

    const [agent_name, SetAgents_name] = useState(null as string || null);
    const [agent_email, SetAgent_email] = useState(null as string || null);
    const [agent_cpf, SetAgent_cpf] = useState(null as string || null);
    const [agent_phone, SetAgent_phone] = useState(null as string || null);
    const [agent_observations, SetAgent_observations] = useState(null as string || null);
    const [agent_isAdministrator, SetAgent_isAdministrator] = useState((props.data && props.data.profile_id === constsApi.profile[0].id) || constsApi.profile[2].id ? true :
        props.data && props.data.profile_id === constsApi.profile[1].id ? false : null);
    const [agent_profile, setAgent_profile] = useState('');
    const [agent_owner, setAgent_owner] = useState(false);
    const [agent_role, setAgent_role] = useState('');

    const [showfeedbackObs, setShowfeedbackObs] = useState(false);
    const [showfeedbackEmail, setShowfeedbackEmail] = useState(false);
    const [showfeedbackName, setShowfeedbackName] = useState(false);
    const [showfeedbackPhone, setShowfeedbackPhone] = useState(false);
    const [showfeedbackCpf, setShowfeedbackCpf] = useState(false);

    // const [phoneTag] = useState("phone");
    // const [phoneError, setPhoneError] = useState(null);

    const [options_country, setOptions_country] = useState([
        { label: t("home_agents.register_modal.form_country.options_country.brazil"), value: 'pt-br' },
        { label: t("home_agents.register_modal.form_country.options_country.portugal"), value: 'pt-pt' },
        { label: t("home_agents.register_modal.form_country.options_country.spain"), value: 'es' },
        { label: t("home_agents.register_modal.form_country.options_country.france"), value: 'fr' },
        { label: t("home_agents.register_modal.form_country.options_country.uk"), value: 'en' },
    ]);
    const [selected_country, setSelected_country] = useState([]);

    const [modalShow, setModalShow] = useState(props.visibility);
    const [border, setBorder] = useState('')
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        setModalShow(props.visibility);
        SetAgent_isAdministrator(props.data && props.data.profile_id === constsApi.profile[0].id ? true :
            props.data && props.data.profile_id === constsApi.profile[1].id ? false : null);
        setAgent_owner(props.data && props.data.profile_id === constsApi.profile[2].id ? true : false)
        setBorder('')
        setShowfeedbackPhone(false)
        switchSelectLanguage(props?.data?.country)

    }, [props.visibility, agent_phone]);

    useEffect(() => {
        switchSelectLanguage(props?.data?.country)
    }, []);

    const Hide = () => {
        setShowfeedbackObs(false);
        setShowfeedbackEmail(false);
        setShowfeedbackName(false);
        setShowfeedbackPhone(false);
        setShowfeedbackCpf(false);
        dispatch(setShowEditAgentsModal(false));
        setModalShow(false);
    }

    const Validate = (values, language) => {
        let errors = {};

        if (!values.name) {
            errors["name"] = `${t('home_agents.edit_modal.validate.name')}`;
            setShowfeedbackName(true);
        } else {
            setShowfeedbackName(false);
        }

        if (!values.email) {
            errors["email"] = `${t('home_agents.edit_modal.validate.email_a')}`;
            setShowfeedbackEmail(true);
        }
        else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,10}$/i.test(values.email) && values.email) {
            errors["email"] = `${t('home_agents.edit_modal.validate.email_b')}`;
            setShowfeedbackEmail(true);
        } else {
            setShowfeedbackEmail(false);
        }

        let number_cpf: string | number;
        if (values.cpf)
            number_cpf = values.cpf.replace(/[^a-zA-Z0-9]/g, '').length;
        if (language === 'pt-pt') {
            if (number_cpf !== 0 && number_cpf !== 9 && number_cpf !== 11 && values.cpf) {
                errors["cpf"] = t('home_agents.register_modal.submit.document_error', { document_type: switchDocument()});
                setShowfeedbackCpf(true);
            } else {
                setShowfeedbackCpf(false);
            }
        } else if (language === 'pt-br') {
            if (number_cpf !== 0 && number_cpf !== 11 && number_cpf !== 14 && values.cpf) {
                errors["cpf"] = t('home_agents.register_modal.submit.document_error', { document_type: switchDocument()});
                setShowfeedbackCpf(true);
            } else {
                setShowfeedbackCpf(false);
            }
        }
        else if (language === 'es') {
            if (number_cpf !== 0 && number_cpf !== 9 && number_cpf !== 11 && values.cpf) {
                errors["cpf"] = t('home_agents.register_modal.submit.document_error', { document_type: switchDocument()});
                setShowfeedbackCpf(true);
            } else {
                setShowfeedbackCpf(false);
            }
        }
        else if (language === 'fr') {
            if (number_cpf !== 0 && number_cpf !== 15 && number_cpf !== 18 && values.cpf) {
                errors["cpf"] = t('home_agents.register_modal.submit.document_error', { document_type: switchDocument()});
                setShowfeedbackCpf(true);
            } else {
                setShowfeedbackCpf(false);
            }
        }
        else if (language === 'en') {
            if (number_cpf !== 0 && number_cpf !== 9 && number_cpf !== 12 && values.cpf) {
                errors["cpf"] = t('home_agents.register_modal.submit.document_error', { document_type: switchDocument()});
                setShowfeedbackCpf(true);
            } else {
                setShowfeedbackCpf(false);
            }
        }

        // if (phoneError !== null)
        //     errors[phoneTag] = phoneError;

        if (values.observations.length > 100) {
            errors["observations"] = `${t('home_agents.edit_modal.validate.observations')}`;
            setShowfeedbackObs(true);
        } else {
            setShowfeedbackObs(false);
        }

        return errors;
    }

    const switchLanguage = () => {
        if (selected_country[0]?.value === 'pt-br') {
            return ['br'];
        } else if (selected_country[0]?.value === 'pt-pt') {
            return ['pt'];
        } else if (selected_country[0]?.value === 'es') {
            return ['es'];
        } else if (selected_country[0]?.value === 'fr') {
            return ['fr'];
        } else if (selected_country[0]?.value === 'en') {
            return ['gb'];
        } else {
            return ['br'];
        }
    }

    const switchSelectLanguage = (language) => {
        if (language === 'BR') {
            setSelected_country([])
            setSelected_country([{ label: t("home_agents.register_modal.form_country.options_country.brazil"), value: 'pt-br' }]);
        } else if (language === 'PT') {
            setSelected_country([])
            setSelected_country([{ label: t("home_agents.register_modal.form_country.options_country.portugal"), value: 'pt-pt' }]);
        } else if (language === 'ES') {
            setSelected_country([])
            setSelected_country([{ label: t("home_agents.register_modal.form_country.options_country.spain"), value: 'es' }]);
        } else if (language === 'FR') {
            setSelected_country([])
            setSelected_country([{ label: t("home_agents.register_modal.form_country.options_country.france"), value: 'fr' }]);
        } else if (language === 'GB') {
            setSelected_country([])
            setSelected_country([{ label: t("home_agents.register_modal.form_country.options_country.uk"), value: 'en' }]);
        }
    }

    const switchDocument = () => {
        if (selected_country[0]?.value === 'pt-br') {
            return 'CPF';
        }
        else if (selected_country[0]?.value === 'pt-pt') {
            return 'NIF';
        }
        else if (selected_country[0]?.value === 'es') {
            return 'NIF';
        }
        else if (selected_country[0]?.value === 'fr') {
            return 'NIR';
        }
        else if (selected_country[0]?.value === 'en') {
            return 'NINO';
        }
        else {
            return 'CPF';
        }
    }

    return <ModalEditAgents
        t={t}
        modalShow={modalShow}
        Hide={Hide}
        props={props}
        dispatch={dispatch}
        navigate={navigate}
        setIsLoading={setIsLoading}
        setShowfeedbackPhone={setShowfeedbackPhone}
        showfeedbackPhone={showfeedbackPhone}
        border={border}
        setBorder={setBorder}
        validated={validated}
        SetAgents_name={SetAgents_name}
        SetAgent_email={SetAgent_email}
        SetAgent_cpf={SetAgent_cpf}
        SetAgent_observations={SetAgent_observations}
        setAgent_profile={setAgent_profile}
        agent_isAdministrator={agent_isAdministrator}
        Validate={Validate}
        agent_name={agent_name}
        agent_profile={agent_profile}
        agent_email={agent_email}
        agent_cpf={agent_cpf}
        agent_phone={agent_phone}
        agent_observations={agent_observations}
        AppRequesterConst={AppRequesterConst}
        showfeedbackName={showfeedbackName}
        showfeedbackEmail={showfeedbackEmail}
        showfeedbackCpf={showfeedbackCpf}
        showfeedbackObs={showfeedbackObs}
        SetAgent_isAdministrator={SetAgent_isAdministrator}
        SetAgent_phone={SetAgent_phone}
        options_country={options_country}
        setOptions_country={setOptions_country}
        selected_country={selected_country}
        setSelected_country={setSelected_country}
        switchLanguage={switchLanguage}
        switchDocument={switchDocument}
        agent_owner={agent_owner}
        agent_role={agent_role}
        setAgent_role={setAgent_role}
    />

}

export default ModalEditAgentsController;